module.exports = __webpack_public_path__ + "img/Silver II.8d5c78a9.png";